<template>
  <div class="page-desc-wrapper" aria-label="Page description">
    <v-btn
      x-small
      icon
      class="page-desc-toggle"
      :aria-expanded="String(expanded)"
      aria-label="Toggle page description"
      @click="expanded = !expanded"
    >
      <v-icon small>
        {{ expanded ? 'mdi-chevron-up' : 'mdi-information-outline' }}
      </v-icon>
    </v-btn>
    <pre v-show="expanded" class="page-desc" v-html="sanitizedContent"></pre>
  </div>
</template>

<script>
import DOMPurify from 'dompurify'

export default {
  name: 'PageDesc',
  props: {
    content: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      expanded: false,
    }
  },
  computed: {
    sanitizedContent() {
      return DOMPurify.sanitize(this.content)
    },
  },
}
</script>
